export default {
    toNumber(number) {
        return new Intl.NumberFormat("ru").format(number);
    },
    toCurrency(number) {
        return new Intl.NumberFormat("ru", {style: "currency", currency: "RUB"}).format(number);
    },
};
